import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list"]

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: "[data-sortable-target='handle']",
      animation: 150,
      onEnd: () => this.renumber()
    })

    this.onChanged = () => this.renumber()
    this.element.addEventListener("routine-blocks:changed", this.onChanged)
    this.renumber()
  }

  disconnect() {
    this.element.removeEventListener("routine-blocks:changed", this.onChanged)
    this.sortable?.destroy()
  }

  renumber() {
    this.listTarget
      .querySelectorAll('[data-routine-blocks-target="row"]:not(.hidden)')
      .forEach((row, index) => {
        row.querySelector('[data-routine-blocks-target="position"]').value = index
      })
  }
}
